import BannerHome from "./Banners/BannerHome";
import Intro from "./Intro/Intro";
import OperacionProductos from "./OperacionProductos/OperacionProductos";

const Home = () => {

    return (
        <div>
            <BannerHome />
            <Intro />
            <OperacionProductos />
        </div>
    );
}

export default Home;
